import React from 'react'

const SearchTitle = ({ title }) => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="sh-category-title">
                    {title}
                </div>
            </div>
        </div>
    )
}

export default SearchTitle